/**
 * RevenueCat product and entitlement identifier constants.
 * @see https://www.revenuecat.com/docs/entitlements
 */
export const RCConstants = {
  keys: {
    REVENUECAT_PUBLIC_API_KEY: 'VITE_REVENUECAT_PUBLIC_API_KEY',
    REVENUECAT_PROJECT_ID: 'VITE_REVENUECAT_PROJECT_ID',
  },
  /** Entitlement identifiers */
  entitlements: {
    ANONYMOUS_USER_ENTITLEMENT_TEST_1: 'ANONYMOUS_USER_ENTITLEMENT_TEST_1',
  },
  /** Product identifiers */
  products: {
    FREE_PRODUCT_1: 'free_product_1',
  },
} as const;
